import dynamic from 'next/dynamic'

export default function asyncComponent(importComponent) {
  return dynamic(importComponent, {
    loading: () => <div></div>,
  })
}
